import React, { useState, useEffect } from 'react';
import { auth, db } from '../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from 'firebase/firestore';
import AIReportPage from '../../components/student/AIReportPage';
import Preloader from '../../components/Preloader';

function StudentAIReports() {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        loadStudentClasses(currentUser);
      } else {
        window.location.href = '/sign-in';
      }
    });
    return () => unsubscribe();
  }, []);

  const loadStudentClasses = async (currentUser) => {
    setLoading(true);
    try {
      const enrollmentsRef = collection(db, 'enrollments');
      const q = query(
        enrollmentsRef,
        where('students', 'array-contains', currentUser.uid)
      );
      const qs = await getDocs(q);

      const cards = [];
      for (const docSnap of qs.docs) {
        const classId = docSnap.id;
        const cls = await getDoc(doc(db, 'classes', classId));
        if (cls.exists()) {
          cards.push({ id: classId, ...cls.data() });
        }
      }
      setClasses(cards);
    } catch (err) {
      console.error('Error loading classes:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Preloader />;

  return (
    <>
      <main className="bg-[var(--bg-color)] text-[var(--text-color)] transition-all">
        <section className="mx-auto max-w-7xl px-0 py-0">
          {selectedClass ? (
            <AIReportPage
              selectedClass={selectedClass}
              closeClass={() => setSelectedClass(null)}
              user={user}
            />
          ) : (
            <>
              <div
                id="class-cards"
                className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3"
              >
                {classes.map((c) => (
                  <div
                    key={c.id}
                    onClick={() => setSelectedClass(c)}
                    className="cursor-pointer rounded-lg border p-4 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md"
                    style={{ backgroundColor: 'var(--card-bg)', borderColor: 'var(--border-color)', boxShadow: 'var(--shadow-sm)' }}
                  >
                    <h3 className="mb-2 truncate text-lg font-semibold">
                      {c.class_name}
                    </h3>
                  </div>
                ))}
              </div>

              {classes.length === 0 && (
                <div className="mt-4 rounded-lg border p-8 text-center" style={{ borderColor: 'var(--border-color)', backgroundColor: 'var(--card-bg)' }}>
                  <p className="text-[var(--muted-color)]">
                    You are not enrolled in any classes.
                  </p>
                </div>
              )}
            </>
          )}
        </section>
      </main>
    </>
  );
}

export default StudentAIReports;
